import { render, staticRenderFns } from "./EntrepreneurVideoDecorative.vue?vue&type=template&id=d252a65e&scoped=true&"
import script from "./EntrepreneurVideoDecorative.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurVideoDecorative.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurVideoDecorative.vue?vue&type=style&index=0&id=d252a65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d252a65e",
  null
  
)

export default component.exports